import * as React from "react"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { useTranslation } from "react-i18next"
import { useStoreRechnung } from "../store"

interface KontaktdatenViewProps {
    basePath: string
}

export function RechnungsempfaengerKontaktdatenView({ basePath }: KontaktdatenViewProps) {
    const { t } = useTranslation()
    const {
        rechnungsempfaenger: {
            empfaenger: { kontaktdaten },
        },
    } = useStoreRechnung("rechnungsempfaenger")

    const onChange = React.useCallback<(path: string) => (value: unknown) => void>(
        (path) => (value) => {
            EventBus.instance.emit("changeProperty", `${basePath}.${path}`, value)
        },
        [basePath],
    )

    return (
        <Components.Collapsible title={t("rechnung.rechnungsempfaenger.kontaktdaten.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.kontaktdaten.name.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.kontaktdaten.name.placeholder")}
                    onChange={onChange("name")}
                    value={kontaktdaten.name}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.kontaktdaten.telefon.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.kontaktdaten.telefon.placeholder")}
                    onChange={onChange("telefon")}
                    value={kontaktdaten.telefon}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.rechnungsempfaenger.kontaktdaten.email.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.rechnungsempfaenger.kontaktdaten.email.placeholder")}
                    onChange={onChange("email")}
                    value={kontaktdaten.email}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
